import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-inbuilt-filter',
    templateUrl: './inbuilt-filter.component.html',
    styleUrl: './inbuilt-filter.component.scss',
    imports: [MatIcon]
})
export class InbuiltFilterComponent {
  @Input() disabled = false;
  @Output() addFilter = new EventEmitter<void>();
}
